import {
  REGISTER_USER_REQUEST,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_FAILURE,
  RESET_REGISTER_STATE,
} from "../../actionTypes/register";

export interface RegisterState {
  isProcessIntiated: boolean;
  error: string | null;
  isLoading : boolean;
}

export interface RegisterAction {
  type: string;
  payload?: string;
}

const initialState: RegisterState = {
  isProcessIntiated: false,
  error: null,
  isLoading: false
};

const register = (
  state = initialState,
  action: RegisterAction,
): RegisterState => {
  switch (action.type) {
    case REGISTER_USER_REQUEST:
      return { ...state, isProcessIntiated: false, error: null , isLoading:true };
    case REGISTER_USER_SUCCESS:
      return { ...state, isProcessIntiated: true, isLoading:false };
    case REGISTER_USER_FAILURE:
      return {
        ...state,
        isProcessIntiated: false,
        isLoading:false,
        error: action.payload ?? null,
      };
    case RESET_REGISTER_STATE:
      return { ...state, isProcessIntiated: false, error: null, isLoading:false };
    default:
      return state;
  }
};

export default register;
